import { render, staticRenderFns } from "./UseCase3.vue?vue&type=template&id=68b97bf5&scoped=true&"
import script from "./UseCase3.vue?vue&type=script&lang=js&"
export * from "./UseCase3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b97bf5",
  null
  
)

export default component.exports